export const isValidUUID = (uuid) => {
    const regexExp = /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return regexExp.test(uuid);
}


// Function to retrieve value based on object path
export const getObjectValue = (obj, path) => {
    if (typeof path !== 'string') {
        return undefined; // Return undefined if path is not a string
    }
    const keys = path.split('.');
    let value = obj;
    for (const key of keys) {
        if (value !== null && typeof value === 'object' && key in value) {
            value = value[key];
        } else {
            return undefined; // Return undefined if the key is not found
        }
    }
    return value;
}


// Function to set value based on object path
export const setObjectValue = (obj, path, value) => {
    const keys = path.split('.');
    let currentObj = obj;
    for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        if (!currentObj[key] || currentObj[key] === null) {
            currentObj[key] = {};
        }
        currentObj = currentObj[key];
    }
    currentObj[keys[keys.length - 1]] = value;
}

// Function to set value based on object path
export const setNestedValue = (obj, path, value) => {
    const keys = path.split('.');
    let currentObj = obj;
    for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        if (!(key in currentObj)) {
            currentObj[key] = {};
        }
        currentObj = currentObj[key];
    }
    currentObj[keys[keys.length - 1]] = value;
}

export const isEmptyObject = (obj) => {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const validateArray = (data, indexes) => {
    let e = false;
    let newValidateData = data.map((dataItem, dataIndex) => {
        let validateDataItem = {};

        indexes.forEach(item => {
            if (item.condition) {
                let value = getObjectValue(dataItem.text, item.index);
                if (!value || isEmptyObject(value)) {
                    validateDataItem[item.index] = false;
                    e = true;
                } else {
                    if (typeof value === 'object' && !Array.isArray(value)) {
                        for (const key in value) {
                            if (item.regex.test(value[key])) {
                                validateDataItem[item.index] = true;
                            } else {
                                validateDataItem[item.index] = false;
                                e = true;
                                break;
                            }
                        }
                    } else {
                        if (item.regex.test(value)) {
                            validateDataItem[item.index] = true;
                        } else {
                            validateDataItem[item.index] = false;
                            e = true;
                        }
                    }
                }
            }
        });

        return validateDataItem;
    });

    return { e, newValidateData };
};



/**
 * Validates a set of data fields against specified conditions and regular expressions.
 * 
 * @param {Object} data - The data object containing fields to validate.
 * @param {Array} indexes - An array of objects describing validation rules, each including:
 *    - index: The field name in the data object to validate.
 *    - condition: A boolean indicating whether this field should be validated.
 *    - regex: A RegExp object against which the field's value will be tested.
 * 
 * @returns {Object} An object containing:
 *    - e: A boolean flag indicating if any validation failed (true if any validations failed).
 *    - newValidateData: An object mapping field names to boolean values indicating
 *      whether each field passed validation (true if the field passed).
 */
export const validate = (data, indexes) => {
    let e = false;
    let newValidateData = {};

    indexes.forEach(item => {
        if (item.condition) {
            let value = getObjectValue(data, item.index);
            if (value === null || isEmptyObject(value) || value === undefined) {
                newValidateData[item.index] = false;
                e = true;
            } else {
                if (typeof value === 'object') {
                    for (const key in value) {
                        if (item.regex.test(value[key])) {
                            newValidateData[item.index] = true;
                        } else {
                            newValidateData[item.index] = false;
                            e = true;
                            break;
                        }
                    }
                } else {
                    if (item.regex.test(value)) {
                        newValidateData[item.index] = true;
                    } else {
                        newValidateData[item.index] = false;
                        e = true;
                    }
                }
            }
        }
    });

    return { e, newValidateData };
};

